import { useLocation } from 'react-router-dom'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getAlertLevelColors } from './helpers'
import { filterAlertsByPage } from './helpers'
import * as Styles from './styles'

const SystemAlerts = ({ alerts }) => {
  const theme = useTheme()
  const alertLevelColors = getAlertLevelColors(theme)
  const { pathname } = useLocation()
  const visibleAlerts = filterAlertsByPage(alerts, pathname)

  if (!visibleAlerts?.length) return null

  return (
    <>
      {visibleAlerts.map((alert, index) => (
        <Styles.Container key={index} color={alertLevelColors[alert?.level]}>
          <WarningIcon size={24} color={theme.colors.text.inverse} weight="light" />
          <Text type="bodyMBold" color={theme.colors.text.inverse}>
            {alert?.text}
          </Text>
        </Styles.Container>
      ))}
    </>
  )
}

export default SystemAlerts
